const popupOpen = "data-popup-open";
const pressed = "data-pressed";
export {
  popupOpen,
  pressed
};
//# sourceMappingURL=CommonTriggerDataAttributes.js.map
